module.exports = __webpack_public_path__ + "static/media/7.4f9b9130.jpg";